/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_AutoInputs */

const cs_enum_auto = /** @type {(inputs: Enum_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automaticky`)
};

const en_enum_auto = /** @type {(inputs: Enum_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

/**
* | output |
* | --- |
* | "Auto" |
*
* @param {Enum_AutoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_auto = /** @type {((inputs?: Enum_AutoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_AutoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_auto(inputs)
	return cs_enum_auto(inputs)
});